
export const matchWildcard = (str:string, rule:string) => {
	const escapeRegex = (s:string) => s.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
	return new RegExp("^" + rule.split("*").map(escapeRegex).join(".*") + "$").test(str);
}

export const matchEmail = (email:string) => {
	const re = /\S+@\S+\.\S+/;
	return re.test(email.toLowerCase());
}